// extracted by mini-css-extract-plugin
export default {"how_it_works":"S1_HowItWorks_how_it_works__yPxWY"};